[
  {
    "id": "npm-package-lock-v3",
    "manager": "npm",
    "version": "10.8.2",
    "directory": "npm/package-lock-v3/basic",
    "lock": "package-lock.json",
    "match": {
      "format": 3,
      "file": "package-lock.json"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "npm-shrinkwrap-v3",
    "manager": "npm",
    "version": "10.8.2",
    "directory": "npm/shrinkwrap-v3/basic",
    "lock": "npm-shrinkwrap.json",
    "match": {
      "format": 3,
      "file": "npm-shrinkwrap.json"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "pnpm-lock-v9",
    "manager": "pnpm",
    "version": "9.15.9",
    "directory": "pnpm/lock-v9/basic",
    "lock": "pnpm-lock.yaml",
    "match": {
      "format": "9.0"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "yarn-classic-v1",
    "manager": "yarn",
    "version": "1.22.22",
    "directory": "yarn/classic-v1/basic",
    "lock": "yarn.lock",
    "match": {
      "format": 1,
      "classic": true
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "yarn-modern-v8",
    "manager": "yarn",
    "version": "4.9.2",
    "directory": "yarn/modern-v8/pnp",
    "lock": "yarn.lock",
    "match": {
      "format": 8,
      "classic": false
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "linker": "pnp",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "npm-package-lock-v1",
    "manager": "npm",
    "version": "6.14.18",
    "directory": "npm/package-lock-v1/basic",
    "lock": "package-lock.json",
    "match": {
      "format": 1,
      "file": "package-lock.json"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "npm-package-lock-v2",
    "manager": "npm",
    "version": "8.19.4",
    "directory": "npm/package-lock-v2/basic",
    "lock": "package-lock.json",
    "match": {
      "format": 2,
      "file": "package-lock.json"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "controlDependencies": {
      "is-number": "6.0.0"
    },
    "node": "16.10.0"
  },
  {
    "id": "pnpm-lock-v5.4",
    "manager": "pnpm",
    "version": "7.33.7",
    "directory": "pnpm/lock-v5.4/basic",
    "lock": "pnpm-lock.yaml",
    "match": {
      "format": "5.4"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "pnpm-lock-v6",
    "manager": "pnpm",
    "version": "8.15.9",
    "directory": "pnpm/lock-v6/basic",
    "lock": "pnpm-lock.yaml",
    "match": {
      "format": "6.0"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "npm-shrinkwrap-v2",
    "manager": "npm",
    "version": "8.19.4",
    "directory": "npm/shrinkwrap-v2/basic",
    "lock": "npm-shrinkwrap.json",
    "match": {
      "format": 2,
      "file": "npm-shrinkwrap.json"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "16.10.0",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "npm-shrinkwrap-v1",
    "manager": "npm",
    "version": "6.14.18",
    "directory": "npm/shrinkwrap-v1/basic",
    "lock": "npm-shrinkwrap.json",
    "match": {
      "format": 1,
      "file": "npm-shrinkwrap.json"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "19.3.0",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "pnpm-lock-v5.1",
    "manager": "pnpm",
    "version": "3.8.1",
    "directory": "pnpm/lock-v5.1/basic",
    "lock": "pnpm-lock.yaml",
    "match": {
      "format": "5.1"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "12.9.1",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "pnpm-lock-v5",
    "manager": "pnpm",
    "version": "3.0.0",
    "directory": "pnpm/lock-v5/basic",
    "lock": "pnpm-lock.yaml",
    "match": {
      "format": "5"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "11.11.0",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "pnpm-lock-v5.2",
    "manager": "pnpm",
    "version": "5.18.11",
    "directory": "pnpm/lock-v5.2/basic",
    "lock": "pnpm-lock.yaml",
    "match": {
      "format": "5.2"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "16.9.1",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "pnpm-lock-v5.3",
    "manager": "pnpm",
    "version": "6.0.0",
    "directory": "pnpm/lock-v5.3/basic",
    "lock": "pnpm-lock.yaml",
    "match": {
      "format": "5.3"
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "15.13.0",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "yarn-modern-v4",
    "manager": "yarn",
    "version": "2.4.3",
    "directory": "yarn/modern-v4/pnp",
    "lock": "yarn.lock",
    "match": {
      "format": 4,
      "classic": false
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "16.8.0",
    "linker": "pnp",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "yarn-modern-v10",
    "manager": "yarn",
    "version": "4.18.0",
    "directory": "yarn/modern-v10/pnp",
    "lock": "yarn.lock",
    "match": {
      "format": 10,
      "classic": false
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "26.5.1",
    "linker": "pnp",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "yarn-modern-v6",
    "manager": "yarn",
    "version": "3.8.7",
    "directory": "yarn/modern-v6/pnp",
    "lock": "yarn.lock",
    "match": {
      "format": 6,
      "classic": false
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "23.3.0",
    "linker": "pnp",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "yarn-modern-v9",
    "manager": "yarn",
    "version": "4.14.0",
    "directory": "yarn/modern-v9/pnp",
    "lock": "yarn.lock",
    "match": {
      "format": 9,
      "classic": false
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "25.9.0",
    "linker": "pnp",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "yarn-modern-v5",
    "manager": "yarn",
    "version": "3.1.0",
    "directory": "yarn/modern-v5/pnp",
    "lock": "yarn.lock",
    "match": {
      "format": 5,
      "classic": false
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "17.0.1",
    "linker": "pnp",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "yarn-modern-v7",
    "manager": "yarn",
    "version": "4.0.0-rc.35",
    "directory": "yarn/modern-v7/pnp",
    "lock": "yarn.lock",
    "match": {
      "format": 7,
      "classic": false
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "19.4.0",
    "linker": "pnp",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "pnpm-legacy-shrinkwrap-v3",
    "manager": "pnpm",
    "version": "2.25.7",
    "directory": "pnpm/legacy-shrinkwrap-v3/basic",
    "lock": "shrinkwrap.yaml",
    "match": {
      "format": "3",
      "file": "shrinkwrap.yaml",
      "features": {
        "sharedWorkspace": false
      }
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "11.10.1",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  },
  {
    "id": "pnpm-legacy-shrinkwrap-v4",
    "manager": "pnpm",
    "version": "2.25.7",
    "directory": "pnpm/legacy-shrinkwrap-v4/shared-workspace",
    "lock": "shrinkwrap.yaml",
    "match": {
      "format": "4",
      "file": "shrinkwrap.yaml",
      "features": {
        "sharedWorkspace": true
      }
    },
    "dependencies": {
      "is-number": "7.0.0"
    },
    "node": "11.10.1",
    "controlDependencies": {
      "is-number": "6.0.0"
    }
  }
]
